/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import styles from "../styles/CobuyerCosellerList.module.css";
import EditCorpOrClient from "./EditCorpOrClient";

function CobuyerCosellerList({ contractAuthKey, currentUrlId, rootDocData = {}, modalState = {}, contractData = {}, renderScreen, }) {
  let sourceType = "NORMAL";

  if (renderScreen === "OFFER_IMPORT") {
    sourceType = "MANUAL_ADD_CLIENTS";
  } else if (rootDocData?.contractType?.startsWith("HH_")) {
    sourceType = "NORMAL";
  } else {
    sourceType = (modalState.clientType === "Sellers" && rootDocData?.openFor === "BUYER_AGENT") || (modalState.clientType === "Buyers" && rootDocData?.openFor === "SELLER_AGENT") ? "MANUAL_ADD_CLIENTS" : "NORMAL";
  }

  return (
    <div className={styles.contentDiv} id="corpSignersList">
      <EditCorpOrClient sourceType={sourceType} currentUrlId={currentUrlId} clientType={modalState.clientType} rootDocData={rootDocData} contractAuthKey={contractAuthKey} modalState={modalState} contractData={contractData} renderScreen={renderScreen} />
    </div>
  );
}

export default CobuyerCosellerList;
